export default "__VITE_ASSET__CS9F0402__"